module.exports = __webpack_public_path__ + "img/Anything-Comfortable.623d1a70.jpg";